module.exports = __webpack_public_path__ + "static/media/backgroundFootball_Transparent.4ef2c91a.svg";